/* eslint-disable import/no-named-as-default */
/* eslint-disable unicorn/prefer-export-from */
import Keys from './Keys.Prod';

export default Keys;
